import React, { Component } from 'react';
import './about.css';
import { BrowserRouter, Route, Link } from 'react-router-dom';


function About (props){
  return(
    <div>
    <h1 className="setup-h1">Setting Up an Account Is Easy!</h1>
    <div className="setup-board">
    <ul className="setup-ul">
        <li>Sign Up for A New Account.</li>
        <li>Follow simple instructions to set up your website.</li>
        <li>Get Charged 10% of each transaction.</li>
        <li>Make $$$ selling Gift Cards - 24 hrs a day!</li>
    </ul>
  </div>
    <div className="signup-button-box">
      <button className="lets-go"><Link to="letsGo">Let's Go!</Link></button></div></div>
    )

}






export default About;



// WEBPACK FOOTER //
// ./src/about.js